import React, { useEffect } from 'react';

const ClosePage = () => {
  useEffect(() => {
    window.close();
  }, []);

  return <p>{'Closing...'}</p>;
};

export default ClosePage;
